import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import './index.css';
import './axiosConfig'; // Import axios interceptor for Safari compatibility

// Pages
import PremiumLandingPage from './pages/PremiumLandingPage';
import LandingPage from './pages/LandingPage';
import AuthCallback from './pages/AuthCallback';
import BrowseCourses from './pages/BrowseCourses';
import CourseDetail from './pages/CourseDetail';
import StudentDashboard from './pages/StudentDashboard';
import CoachDashboard from './pages/CoachDashboard';
import BecomeCoach from './pages/BecomeCoach';
import CreateCourse from './pages/CreateCourse';
import CreateCoursePage from './pages/CreateCoursePage';
import PaymentSuccess from './pages/PaymentSuccess';
import FindCoach from './pages/FindCoach';
import AdminDashboard from './pages/AdminDashboard';
import AdminPartnersPage from './pages/AdminPartnersPage';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import ChatPage from './pages/ChatPage';
import ReferralPage from './pages/ReferralPage';
import StudentLevelPage from './pages/StudentLevelPage';
import CoachCredentials from './pages/CoachCredentials';
import FacilitiesPage from './pages/FacilitiesPage';
import FacilityDetailPage from './pages/FacilityDetailPage';
import CoachesPage from './pages/CoachesPage';
import CoachDetailPage from './pages/CoachDetailPage';
import CoachApplicationForm from './pages/CoachApplicationForm';
import FacilityApplicationForm from './pages/FacilityApplicationForm';
import MyBookingsPage from './pages/MyBookingsPage';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import { Toaster as SonnerToaster } from './components/ui/sonner';
import { Toaster } from 'react-hot-toast';

function AppRouter() {
  const location = useLocation();
  
  // CRITICAL: Check for session_id synchronously during render to prevent race conditions
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<PremiumLandingPage />} />
        <Route path="/courses" element={<BrowseCourses />} />
        <Route path="/courses/:id" element={<CourseDetail />} />
        <Route path="/become-coach" element={<BecomeCoach />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/find-coach" element={<FindCoach />} />
        <Route path="/synergies/facilities" element={<FacilitiesPage />} />
        <Route path="/synergies/facilities/:facilityId" element={<FacilityDetailPage />} />
        <Route path="/synergies/coaches" element={<CoachesPage />} />
        <Route path="/synergies/coaches/:coachId" element={<CoachDetailPage />} />
        <Route path="/synergies/apply/coach" element={<CoachApplicationForm />} />
        <Route path="/synergies/apply/facility" element={<FacilityApplicationForm />} />
        
        {/* Protected Routes */}
        <Route path="/my-bookings" element={
          <ProtectedRoute>
            <MyBookingsPage />
          </ProtectedRoute>
        } />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <StudentDashboard />
          </ProtectedRoute>
        } />
        <Route path="/coach/dashboard" element={
          <ProtectedRoute>
            <CoachDashboard />
          </ProtectedRoute>
        } />
        <Route path="/coach/courses/new" element={
          <ProtectedRoute>
            <CreateCoursePage />
          </ProtectedRoute>
        } />
        <Route path="/coach/courses/:id/edit" element={
          <ProtectedRoute>
            <CreateCourse />
          </ProtectedRoute>
        } />
        <Route path="/admin" element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin/dashboard" element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin/partners" element={
          <ProtectedRoute>
            <AdminPartnersPage />
          </ProtectedRoute>
        } />
        <Route path="/admin/analytics" element={
          <ProtectedRoute>
            <AnalyticsDashboard />
          </ProtectedRoute>
        } />
        <Route path="/messages" element={
          <ProtectedRoute>
            <ChatPage />
          </ProtectedRoute>
        } />
        <Route path="/messages/:conversationId" element={
          <ProtectedRoute>
            <ChatPage />
          </ProtectedRoute>
        } />
        <Route path="/referrals" element={
          <ProtectedRoute>
            <ReferralPage />
          </ProtectedRoute>
        } />
        <Route path="/my-levels" element={
          <ProtectedRoute>
            <StudentLevelPage />
          </ProtectedRoute>
        } />
        <Route path="/coach/credentials" element={
          <ProtectedRoute>
            <CoachCredentials />
          </ProtectedRoute>
        } />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <SonnerToaster position="top-right" />
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: '#1a0a2e',
            color: '#fff',
            border: '1px solid rgba(201, 168, 76, 0.3)'
          }
        }}
      />
    </div>
  );
}

export default App;
